// src/pages/Profile.js
import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { User, Mail, Key } from "lucide-react"; // Icons

export default function Profile() {
    const [userEmail, setUserEmail] = useState("");

    useEffect(() => {
        // Fetch user email from token (similar to Navbar)
        const token = localStorage.getItem('piwatch_token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserEmail(decoded.sub || "N/A");
            } catch (e) {
                console.error("Failed to decode token for profile:", e);
                setUserEmail("Error loading email");
            }
        }
    }, []);

    return (
        <div className="min-h-screen bg-darkBg text-white p-6">
            <header className="mb-10 text-center">
                <h1 className="text-4xl font-extrabold text-neonBlue custom-glow-text">
                    👤 Your Profile
                </h1>
                <p className="text-gray-400 mt-2">Manage your account details.</p>
            </header>

            <div className="glass-card glow-border p-8 max-w-lg mx-auto rounded-xl">
                <div className="flex items-center mb-6">
                    <Mail className="text-neonPink mr-3" size={24} />
                    <span className="text-lg font-medium">Email:</span>
                    <span className="ml-2 text-gray-300">{userEmail}</span>
                </div>

                {/* Placeholder for future profile editing */}
                <div className="mt-8 border-t border-gray-700 pt-6">
                    <h3 className="text-xl font-semibold text-neonPink mb-4">Account Actions</h3>
                    <p className="text-gray-400 mb-4">
                        (Future features: Change name, update password, etc.)
                    </p>
                    <button
                        disabled // Disabled for now
                        className="bg-gray-600 text-gray-400 px-4 py-2 rounded-lg cursor-not-allowed mr-4"
                    >
                        Edit Profile (Coming Soon)
                    </button>
                     <button
                         disabled // Disabled for now
                         className="bg-gray-600 text-gray-400 px-4 py-2 rounded-lg cursor-not-allowed"
                     >
                         Change Password (Coming Soon)
                     </button>
                </div>
            </div>
        </div>
    );
}